'use client'

import React from 'react'

import { SubmitScoreboardFormSection } from 'Components/Sections'
import { Column } from 'Components/UI'

function SubmitScoreboardPage() {
  return (
    <Column alignCenter fullWidth mb={[9, 9, 9, 16]} mt={[0, 0, 5]}>
      <SubmitScoreboardFormSection />
    </Column>
  )
}

export default SubmitScoreboardPage
